export const SELF_REGISTRATION_NO = '0';
export const SELF_REGISTRATION_ENTER_NUMBER = '1';
export const SELF_REGISTRATION_GENERATE_NUMBER = '2';
